import { render, staticRenderFns } from "./InputFieldDate.vue?vue&type=template&id=06e2d3c6&scoped=true"
import script from "./InputFieldDate.vue?vue&type=script&lang=js"
export * from "./InputFieldDate.vue?vue&type=script&lang=js"
import style0 from "./InputFieldDate.vue?vue&type=style&index=0&id=06e2d3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2d3c6",
  null
  
)

export default component.exports